@if (_options && _options.series) {
  <highcharts-chart
    [Highcharts]="Highcharts"
    [options]="_options"
    [ngStyle]="{ display: 'block' }"
    [style.height.px]="height"
    [style.min-width.px]="width"
  >
  </highcharts-chart>
}
@if (showLegend && _options && _options.series) {
  <ea-charts-legend [options]="_options" [series]="_options.series">
  </ea-charts-legend>
}
